import { createAction, props } from '@ngrx/store';
import { Wellness } from '@app/core/models';

export const initializeCompletionReportPage = createAction(
  '[Wellness] Initialize Completion Report Page',
);

export const initializeTeamRisksPage = createAction(
  '[Wellness] Initialize Team Risks Page',
);

export const getTeamWellnessCheckInHotelsSuccess = createAction(
  '[Wellness] Get Team Wellness Check In Hotels Success',
  props<{ hotels: Wellness.Hotel[] }>(),
);

export const getTeamWellnessCheckInHotelsFailure = createAction(
  '[Wellness] Get Team Wellness Check In Hotels Failure',
  props<{ message: string }>(),
);

export const getTeamWellnessCheckInReport = createAction(
  '[Wellness] Get Team Wellness Check In Report',
  props<{ entId: string; date: string }>(),
);

export const getTeamWellnessCheckInReportSuccess = createAction(
  '[Wellness] Get Team Wellness Check In Report Success',
  props<{ report: Wellness.CompletionReportEntity }>(),
);

export const getTeamWellnessCheckInReportFailure = createAction(
  '[Wellness] Get Team Wellness Check In Report Failure',
  props<{ message: string }>(),
);

export const getTeamWellnessCheckInRisks = createAction(
  '[Wellness] Get Team Wellness Check In Risks',
  props<{ entId: string }>(),
);

export const getTeamWellnessCheckInRisksSuccess = createAction(
  '[Wellness] Get Team Wellness Check In Risks Success',
  props<{ risks: Wellness.Risk[] }>(),
);

export const getTeamWellnessCheckInRisksFailure = createAction(
  '[Wellness] Get Team Wellness Check In Risks Failure',
  props<{ message: string }>(),
);

export const setTeamRisksMenuSelection = createAction(
  '[Wellness] Set Team Risks Menu Selection',
  props<{ entId: string }>(),
);

export const setCompletionReportMenuSelection = createAction(
  '[Wellness] Set Completion Report Menu Selection',
  props<{ entId: string; date: string }>(),
);
